import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isShowPopupShow: false,
    loadShow: false,
    pendingRequests: 0
  },
  mutations: {
    changeIsShowPopupShow(state, payload) {
      state.isShowPopupShow = payload
    },
    showLoading(state) {
      state.pendingRequests += 1
      state.loadShow = true
    },
    // 隐藏loading的方法
    hideLoading(state) {
      state.pendingRequests = Math.max(0, state.pendingRequests - 1)
      state.loadShow = state.pendingRequests > 0
    },
  },
  actions: {},
  modules: {}
})
